module.exports = __webpack_public_path__ + "files/5119bd37833359e3a86257b5a03632e9.png";